export default __webpack_public_path__ + "static/media/bg03.9df60589.jpg";